<template>
  <triangle-header :seed="user.id" class="user-header">
    <h1 class="display-1">
      <v-icon v-if="user.locked_at">lock_outline</v-icon>
      <v-icon v-if="user.risky_at">warning</v-icon>
      {{ user.nickname }}
    </h1>
    <div class="actions">
      <user-message-button
        v-if="$can('use', 'messenger')"
        :user="user">
        {{ $t('user.header.messenger') }}
      </user-message-button>
      <v-menu v-if="$can('view', 'customers')" bottom left origin="top right">
        <v-btn slot="activator" primary light>
          {{ $t('user.header.more') }}
          <v-icon light>arrow_drop_down</v-icon>
        </v-btn>
        <v-list>
          <v-list-item v-if="user.locked_at">
            <v-list-tile @click.native.stop="confirm(unlock, $t('user.header.unlockreason'))">
              <v-list-tile-title>
                <v-icon>lock_open</v-icon>
                {{ $t('user.header.unlock') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list-item>
          <v-list-item v-else>
            <v-list-tile @click.native.stop="confirm(lock, $t('user.header.lockreason'))">
              <v-list-tile-title>
                <v-icon>lock_outline</v-icon>
                {{ $t('user.header.lock') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list-item>
          <v-list-item v-if="user.risky_at">
            <v-list-tile @click.native.stop="confirm(unrisk, $t('user.header.unriskreason'))">
              <v-list-tile-title>
                <v-icon>warning</v-icon>
                {{ $t('user.header.unrisk') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list-item>
          <v-list-item v-else>
            <v-list-tile @click.native.stop="confirm(risk, $t('user.header.riskreason'))">
              <v-list-tile-title>
                <v-icon>warning</v-icon>
                {{ $t('user.header.risk') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list-item>
          <v-list-item>
            <v-list-tile @click.native="minutesPopup = true">
              <v-list-tile-title>
                <v-icon>card_giftcard</v-icon>
                {{ $t('user.header.minute_gift') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-dialog v-model="minutesPopup" lazy width="480">
        <minute-gift-form
          :user="user"
          @created="minutesPopup = false">
        </minute-gift-form>
      </v-dialog>
    </div>
  </triangle-header>
</template>

<script>
  import { mapActions } from 'vuex'
  import TriangleHeader from '@/components/TriangleHeader.vue'
  import UserMessageButton from '@/components/user/MessageButton.vue'
  import MinuteGiftForm from '@/components/MinuteGiftForm'
  import user from '@/mixins/user'
  export default {
    components: {
      TriangleHeader,
      UserMessageButton,
      MinuteGiftForm
    },
    mixins: [user],
    data () {
      return {
        minutesPopup: false
      }
    },
    methods: {
      ...mapActions({
        lock: 'skiliko/users/lock',
        unlock: 'skiliko/users/unlock',
        risk: 'skiliko/users/risk',
        unrisk: 'skiliko/users/unrisk'
      }),
      confirm (action, text) {
        action({
          id: this.user.id,
          reason: prompt(text)
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../variables"

  @media $display-breakpoints.sm-and-down {
    .user-header {
      // height: 200px;
    }
  }

  .display-1 {
    position: absolute;
    text-shadow: 0 0 1px white;
    bottom: 20px;
    left: 20px;
    margin: 0;
    @media $display-breakpoints.sm-and-down {
      top: 20px;
      bottom: auto;
    }
  }

  .actions {
    position: absolute;
    bottom: 20px;
    right: 20px;
    margin: 0;
  }

  .actions a {
    margin: 0;
  }
</style>




// WEBPACK FOOTER //
// src/components/user/Header.vue